<app-mens-intimate-wash>
  <p class="mb-4">
    If you've had sex while experiencing Bacterial Vaginosis (BV), the bacteria can transfer to your partner's penis,
    creating a risk of reinfection for both of you. This could potentially disrupt your recovery and prolong your
    symptoms. To break this cycle, our specially formulated <strong>Penile Bacteria Wash</strong> is designed to
    effectively eliminate these bacteria and reduce the chance of reinfection.
  </p>
  <p class="mb-4">
    Using this wash daily for 5 days helps ensure that you and your partner are both
    <strong>fully cleansed of any lingering bacteria</strong>, allowing you to complete your treatment with confidence
    and avoid setbacks.
  </p>
</app-mens-intimate-wash>
